import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";
import { VLogo } from "@/components/VLogo";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer className="footer" data-testid="footer">
      <div className="footer__top">
        <VLogo height={190} className="footer__logo" />
        <p className="footer__quote">
          {t.footer.quoteA}
          <br />
          {t.footer.quoteB}
        </p>
      </div>
      <div className="footer__meta">
        <p className="footer__season">{t.footer.season}</p>
        <div className="footer__links">
          <Link to="/menu" data-testid="footer-link-menu">{t.footer.menu}</Link>
          <a href="https://www.instagram.com/vammos.sandlife/" target="_blank" rel="noreferrer" data-testid="footer-link-ig">Instagram · @vammos.sandlife</a>
          <a href="https://www.facebook.com/profile.php?id=61591432117495" target="_blank" rel="noreferrer" data-testid="footer-link-fb">Facebook</a>
          <a href="tel:+306936614442" data-testid="footer-link-phone">+30 6936 61 44 42</a>
        </div>
        <div className="footer__tags">
          <span>#vammos</span><span>#sandlife</span><span>#varkiza</span><span>#αμμος</span><span>#sunsetsets</span>
        </div>
        <p className="footer__rights">© 2026 {t.footer.rights}</p>
      </div>
    </footer>
  );
};

export default Footer;
